import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import SupplyAndDischargeLogForm from "./SupplyAndDischargeLogForm";

const EditSupplyAndDischargeLog = () => {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("id", id);

    post(ApiURL.ods_refrigerant_log_get, fd).then((res) => {
      if (res?.status == true) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  const handleSuccess = () => {
    navigate("/supply-and-discharge-log");
  };

  return (
    <>
      <h2>Edit Supply and Discharge Log</h2>
      <SupplyAndDischargeLogForm
        mode="edit"
        odsId={id}
        logId={details?.log_id}
        logs={[details]}
        onSaveSuccess={handleSuccess}
      />
    </>
  );
};

export default EditSupplyAndDischargeLog;
